import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'saeculum-reactive-form-field',
    templateUrl: './reactive-field-component.html',
    styleUrls: ['./reactive-field-component.scss']

})
export class SaeculumAngularFormlyFieldComponent implements OnInit {
    @Input() formField: any;
    @Input() options: any;
    @Input() values: any;
    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();

    constructor() { }
    ngOnInit() {
    }

    onValueChange(event) {
        this.valueChange.emit(event);
    }
}
